import React from 'react';
import PageHeader from '../components/PageHeader';
import '../css/deansw.css'; // Update the CSS file name

const Resultpage = () => {
    return (

        <div class="container">

            <div class="row">

                <p>


                    <h3 align='center'>
                        NATIONAL INSTITUTE OF TECHNOLOGY, WARANGAL
                    </h3>
                    <h4 align='center'>
                        Ph.D. ADMISSIONS: JULY - 2025 SESSION
                    </h4>
                    <h5 align='center'><u>
                        LIST OF PROVISIONALLY SELECTED CANDIDATES</u>
                    </h5>
                    <p>
                        The interviews for the shortlisted candidates were conducted during <b>13-16, May, 2025</b>. Based on overall performance, the following candidates are provisionally selected for Ph.D. admissions of July, 2025 session. 
                        <b> At the end of the list, the instructions to be followed by the candidates are given. The candidates are informed to follow the instructions given therein strictly.</b>
                    </p>
                    <h5><b>Department of Civil Engineering:</b></h5>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>
                                    Sl. No.
                                </td>
                                <td>
                                    Application ID
                                </td>
                                <td>
                                    Type of Selection
                                </td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>PH125CE00009</td>
                                <td>Institute Fellowship</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>PH125CE00030</td>
                                <td>Institute Fellowship</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>PH125CE00032</td>
                                <td>Institute Fellowship</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>PH125CE00035</td>
                                <td>Institute Fellowship</td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>PH125CE00040</td>
                                <td>Institute Fellowship</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>PH125CE00089</td>
                                <td>Institute Fellowship</td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>PH125CE00034</td>
                                <td>Under Project</td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>PH125CE00007</td>
                                <td>Part Time</td>
                            </tr>
                            <tr>
                                <td>9</td>
                                <td>PH125CE00017</td>
                                <td>Part Time</td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>PH125CE00018</td>
                                <td>Part Time</td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>PH125CE00021</td>
                                <td>Part Time</td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>PH125CE00025</td>
                                <td>Part Time</td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>PH125CE00046</td>
                                <td>Part Time</td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>PH125CE00049</td>
                                <td>Part Time</td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>PH125CE00053</td>
                                <td>Part Time</td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>PH125CE00057</td>
                                <td>Part Time</td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>PH125CE00074</td>
                                <td>Part Time</td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>PH125CE00078</td>
                                <td>Part Time</td>
                            </tr>
                            <tr>
                                <td>19</td>
                                <td>PH125CE00083</td>
                                <td>Part Time</td>
                            </tr>

                        </tbody>
                    </table>


                    <h5><b>Department of Electrical Engineering:</b></h5>


                    <table className="table table-bordered"> <tbody>
                        <tr>
                            <td>
                                Sl. No.
                            </td>
                            <td>
                                Application ID
                            </td>
                            <td>
                                Type of Selection
                            </td>

                        </tr>
                        <tr>
                            <td>1</td>
                            <td>PH125EE00016</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>PH125EE00010</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>PH125EE00018</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>PH125EE00037</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>PH125EE00004</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>PH125EE00040</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>PH125EE00047</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>8</td>
                            <td>PH125EE00033</td>
                            <td>Part Time</td>
                        </tr>

                    </tbody> </table>

                    <h5><b>Department of Mechanical Engineering:</b></h5>

                    <table className="table table-bordered"> <tbody>
                        <tr>
                            <td>
                                Sl. No.
                            </td>
                            <td>
                                Application ID
                            </td>
                            <td>
                                Type of Selection
                            </td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>PH125ME00004</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>PH125ME00028</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>PH125ME00003</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>PH125ME00010</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>PH125ME00012</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>PH125ME00018</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>PH125ME00019</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>8</td>
                            <td>PH125ME00011</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>9</td>
                            <td>PH125ME00017</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>10</td>
                            <td>PH125ME00024</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>11</td>
                            <td>PH125ME00026</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>12</td>
                            <td>PH125ME00029</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>13</td>
                            <td>PH125ME00031</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>14</td>
                            <td>PH125ME00033</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>15</td>
                            <td>PH125ME00036</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>16</td>
                            <td>PH125ME00041</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>17</td>
                            <td>PH125ME00044</td>
                            <td>Part Time</td>
                        </tr>

                    </tbody> </table>


                    <h5><b>Department of Electronics and Communications Engineering:</b></h5>



                    <table className="table table-bordered"> <tbody>
                        <tr>
                            <td>
                                Sl. No.
                            </td>
                            <td>
                                Application ID
                            </td>
                            <td>
                                Type of Selection
                            </td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>PH125EC00006</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>PH125EC00007</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>PH125EC00034</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>PH125EC00081</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>PH125EC00067</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>PH125EC00002</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>PH125EC00004</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>8</td>
                            <td>PH125EC00012</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>9</td>
                            <td>PH125EC00015</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>10</td>
                            <td>PH125EC00024</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>11</td>
                            <td>PH125EC00044</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>12</td>
                            <td>PH125EC00045</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>13</td>
                            <td>PH125EC00047</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>14</td>
                            <td>PH125EC00054</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>15</td>
                            <td>PH125EC00064</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>16</td>
                            <td>PH125EC00070</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>17</td>
                            <td>PH125EC00074</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>18</td>
                            <td>PH125EC00076</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>19</td>
                            <td>PH125EC00086</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>20</td>
                            <td>PH125EC00088</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>21</td>
                            <td>PH125EC00089</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>22</td>
                            <td>PH125EC00097</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>23</td>
                            <td>PH125EC00098</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>24</td>
                            <td>PH125EC00100</td>
                            <td>Part Time</td>
                        </tr>

                    </tbody> </table>




                    <h5><b>Department of Metallurgical and Materials Engineering:</b></h5>

                    <table className="table table-bordered"> <tbody>
                        <tr>
                            <td>
                                Sl. No.
                            </td>
                            <td>
                                Application ID
                            </td>
                            <td>
                                Type of Selection
                            </td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>PH125MM00001</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>PH125MM00005</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>PH125MM00010</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>PH125MM00014</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>PH125MM00002</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>PH125MM00008</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>PH125MM00013</td>
                            <td>Part Time</td>
                        </tr>

                    </tbody> </table>



                    <h5><b>Department of Chemical Engineering:</b></h5>



                    <table className="table table-bordered"> <tbody>
                        <tr>
                            <td>
                                Sl. No.
                            </td>
                            <td>
                                Application ID
                            </td>
                            <td>
                                Type of Selection
                            </td>

                        </tr>

                        <tr>
                            <td>1</td>
                            <td>PH125CH00003</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>PH125CH00008</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>PH125CH00011</td>
                            <td>External-CSIR</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>PH125CH00006</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>PH125CH00009</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>PH125CH00016</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>PH125CY00026</td>
                            <td>Part Time</td>
                        </tr>

                    </tbody> </table>



                    <h5><b>Department of Computer Science and Engineering:</b></h5><br/>
			{/* <p style={{color:"red"}}>Results will be displayed later.</p> */}

                   <table className="table table-bordered"> <tbody>
                        <tr>
                            <td>
                                Sl. No.
                            </td>
                            <td>
                                Application ID
                            </td>
                            <td>
                                Type of Selection
                            </td>

                        </tr>
                        <tr>
                            <td>1</td>
                            <td>PH125CS00044</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>PH125CS00196</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>PH125CS00298</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>PH125CS00062</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>PH125CS00210</td>
                            <td>Under Project</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>PH125CS00240</td>
                            <td>Self-Finance</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>PH125CS00003</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>8</td>
                            <td>PH125CS00013</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>9</td>
                            <td>PH125CS00027</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>10</td>
                            <td>PH125CS00036</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>11</td>
                            <td>PH125CS00075</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>12</td>
                            <td>PH125CS00085</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>13</td>
                            <td>PH125CS00108</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>14</td>
                            <td>PH125CS00114</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>15</td>
                            <td>PH125CS00136</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>16</td>
                            <td>PH125CS00146</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>17</td>
                            <td>PH125CS00154</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>18</td>
                            <td>PH125CS00162</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>19</td>
                            <td>PH125CS00198</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>20</td>
                            <td>PH125CS00206</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>21</td>
                            <td>PH125CS00208</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>22</td>
                            <td>PH125CS00212</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>23</td>
                            <td>PH125CS00218</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>24</td>
                            <td>PH125CS00233</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>25</td>
                            <td>PH125CS00255</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>26</td>
                            <td>PH125CS00256</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>27</td>
                            <td>PH125CS00265</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>28</td>
                            <td>PH125CS00268</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>29</td>
                            <td>PH125CS00273</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>30</td>
                            <td>PH125CS00283</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>31</td>
                            <td>PH125CS00319</td>
                            <td>Part Time</td>
                        </tr>


                    </tbody> </table>





                    <h5><b>Department of Biotechnology:</b></h5>


                    <table className="table table-bordered"> <tbody>
                        <tr>
                            <td>
                                Sl. No.
                            </td>
                            <td>
                                Application ID
                            </td>
                            <td>
                                Type of Selection
                            </td>
                        </tr>
                        {/* <tr>
                            <td>1</td>
                            <td>PH125BT00004</td>
                            <td>Institute Fellowship</td>
                        </tr> */}
                        <tr>
                            <td>1</td>
                            <td>PH125BT00089</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        {/* <tr>
                            <td>3</td>
                            <td>PH125BT00095</td>
                            <td>Institute Fellowship</td>
                        </tr> */}
                        <tr>
                            <td>2</td>
                            <td>PH125BT00109</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>PH125BT00112</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>PH125BT00118</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>PH125BT00090</td>
                            <td>Part Time</td>
                        </tr>

                    </tbody> </table>




                    <h5><b>Department of Mathematics:</b></h5>



                    <table className="table table-bordered"> <tbody>
                        <tr>
                            <td>
                                Sl. No.
                            </td>
                            <td>
                                Application ID
                            </td>
                            <td>
                                Type of Selection
                            </td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>PH125MA00013</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>PH125MA00033</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>PH125MA00042</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>PH125MA00040</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>PH125MA00054</td>
                            <td>CSIR-JRF</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>PH125MA00020</td>
                            <td>Part Time</td>
                        </tr>

                    </tbody> </table>



                    <h5><b>Department of Physics:</b></h5>



                    <table className="table table-bordered"> <tbody>
                        <tr>
                            <td>
                                Sl. No.
                            </td>
                            <td>
                                Application ID
                            </td>
                            <td>
                                Type of Selection
                            </td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>PH125PH00003</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>PH125PH00006</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>PH125PH00023</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>PH125PH00027</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>PH125PH00037</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>PH125PH00040</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>PH125PH00028</td>
                            <td>INSPIRE</td>
                        </tr>
                        <tr>
                            <td>8</td>
                            <td>PH125PH00020</td>
                            <td>External - ARCI</td>
                        </tr>
                        <tr>
                            <td>9</td>
                            <td>PH125PH00021</td>
                            <td>Part Time</td>
                        </tr>

                    </tbody> </table>



                    <h5><b>Department of Chemistry:</b></h5>

                    <table className="table table-bordered"> <tbody>
                        <tr>
                            <td>
                                Sl. No.
                            </td>
                            <td>
                                Application ID
                            </td>
                            <td>
                                Type of Selection
                            </td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>PH125CY00020</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>PH125CY00021</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>PH125CY00022</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>PH125CY00038</td>
                            <td>Institute Fellowship</td>
                        </tr>
                    </tbody> </table>






                    <h5><b>Department of Management Studies:</b></h5>


                    <table className="table table-bordered"> <tbody>
                        <tr>
                            <td>
                                Sl. No.
                            </td>
                            <td>
                                Application ID
                            </td>
                            <td>
                                Type of Selection
                            </td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>PH125MS00007</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>PH125MS00012</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>PH125MS00030</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>PH125MS00032</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>PH125MS00033</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>PH125MS00037</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>PH125MS00001</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>8</td>
                            <td>PH125MS00008</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>9</td>
                            <td>PH125MS00024</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>10</td>
                            <td>PH125MS00047</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>11</td>
                            <td>PH125MS00050</td>
                            <td>Part Time</td>
                        </tr>


                    </tbody> </table>


                    <h5><b>Department of Humanities and Social Sciences:</b></h5>

                    <table className="table table-bordered"> <tbody>
                        <tr>
                            <td>
                                Sl. No.
                            </td>
                            <td>
                                Application ID
                            </td>
                            <td>
                                Type of Selection
                            </td>

                        </tr>
                        <tr>
                            <td>1</td>
                            <td>PH125HS00004</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>PH125HS00012</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>PH125HS00023</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>PH125HS00025</td>
                            <td>Institute Fellowship</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>PH125HS00002</td>
                            <td>Part Time</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>PH125HS00017</td>
                            <td>Part Time</td>
                        </tr>

                    </tbody> </table>
                    <br/>


                    <ol>
                        <li><a href='https://nitw.ac.in/api/static/files/phd_instruactions_2025_2025-5-26-16-39-52.pdf' class="btn btn-primary" target='_blank'>1. Instructions and Physical Reporting schedule for the provisionally selected candidates for Phd Programme July Session 2025.</a></li>

                    </ol>

                    {/* <br></br>
                    <br></br>
                    <b>Associate Dean Admissions      </b>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <b>DEAN, ACADEMIC</b>
                    <br></br>
                    <br></br> */}
                </p>

            </div>
        </div>
    );
};

export default Resultpage;